module.exports = __webpack_public_path__ + "img/f64450a9e9c19da8a3efea9e036f802a.png";